import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-product-card]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-datalayer-product-card-links] a').forEach((cardDownload) => {
    cardDownload.addEventListener('click', datalayerProductCardLinks);
  });
}

function datalayerProductCardLinks(e) {
  let titleText = e.target.closest('[data-au-product-card]').querySelector('[data-au-product-card-title]').innerText,
    clickText = e.target.querySelector(':not([data-au-icon])').innerText;
  const content_type = e.target.hasAttribute('download') ? 'clickDescarga' : 'clickEnlace';

  titleText = titleText.length > 100 ? `${titleText.substring(0, 100)}...` : titleText;
  clickText = clickText.length > 100 ? `${clickText.substring(0, 100)}...` : clickText;

  const item_id = removeAccentMarkAndUppercase(`${titleText}_${clickText}`);

  window.dataLayer.push({
    event: 'navigation',
    content_type,
    item_id,
  });
}

export default { init };
